/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

export interface SplitButtonMenuProps {
  children: React.ReactElement | React.ReactElement[];
}

/**
 * `SplitButton.Menu` subcomponents.
 * Collects incoming props `SplitButton` may use to render a `MenuButton`.
 */
export const SplitButtonMenu = ({ children }) => <></>;
export const SplitButtonMenuItem = ({
  label,
  startIcon,
  endIcon,
  onSelect,
}) => <></>;
